export default class ESigningFormPersonalNumber {
    /**
     * @description Normalize personal number to YYYYMMDD-XXXX and auto-add century for YYMMDD-XXXX
     * @param {string} value - Raw personal number input
     * @returns {string}
     */
    static normalizePersonalNumber(value) {
        const stripped = (value || '').replace(/\s+/g, '').replace(/[^\d-]/g, '');
        let digits = stripped.replace(/-/g, '');

        if (digits.length === 10) {
            const yy = parseInt(digits.substring(0, 2), 10);
            const currentYearTwoDigits = new Date().getFullYear() % 100;
            const century = yy > currentYearTwoDigits ? '19' : '20';
            digits = `${century}${digits}`;
        }

        if (digits.length !== 12) {
            return stripped;
        }

        return `${digits.substring(0, 8)}-${digits.substring(8, 12)}`;
    }

    /**
     * @description Mask last four digits of personal number
     * @param {*} form
     * @param {string} personalNumber
     * @returns {string}
     */
    static maskPersonalNumberLastFour(form, personalNumber) {
        const normalizedPersonalNumber = ESigningFormPersonalNumber.normalizePersonalNumber(personalNumber);
        return normalizedPersonalNumber.replace(/(\d{8}-)\d{4}$/, '$1****');
    }

    /**
     * @description Check if ReceiverPersonalNumber was populated from dropdown
     * @returns {boolean}
     */
    static isReceiverPersonalNumberFromDropdown() {
        const receiverPersonalNumberInput = document.getElementById('ReceiverPersonalNumber');
        return receiverPersonalNumberInput?.dataset?.fromDropdown === 'true';
    }

    /**
     * @description Keep input disabled state in sync with masked dropdown mode
     * @param {*} form
     * @returns void
     */
    static syncReceiverPersonalNumberInputState(form) {
        const receiverPersonalNumberInput = document.getElementById('ReceiverPersonalNumber');
        if (!receiverPersonalNumberInput) {
            return;
        }

        receiverPersonalNumberInput.disabled = ESigningFormPersonalNumber.isReceiverPersonalNumberFromDropdown();
    }

    /**
     * @description Get normalized personal number used for validation and payload
     * @param {*} form
     * @returns {string}
     */
    static getReceiverPersonalNumberValue(form) {
        const receiverPersonalNumberInput = document.getElementById('ReceiverPersonalNumber');
        if (!receiverPersonalNumberInput) {
            return '';
        }

        if (ESigningFormPersonalNumber.isReceiverPersonalNumberFromDropdown()) {
            return ESigningFormPersonalNumber.normalizePersonalNumber(receiverPersonalNumberInput.dataset.rawValue || '');
        }

        return ESigningFormPersonalNumber.normalizePersonalNumber(receiverPersonalNumberInput.value || '');
    }

    /**
     * @description Set personal number from dropdown and mask display value
     * @param {*} form
     * @param {string} personalNumber
     * @returns void
     */
    static setReceiverPersonalNumberFromDropdown(form, personalNumber) {
        const receiverPersonalNumberInput = document.getElementById('ReceiverPersonalNumber');
        if (!receiverPersonalNumberInput) {
            return;
        }

        const normalizedPersonalNumber = ESigningFormPersonalNumber.normalizePersonalNumber(personalNumber);
        if (!normalizedPersonalNumber) {
            ESigningFormPersonalNumber.clearReceiverPersonalNumberDropdownState(form);
            receiverPersonalNumberInput.value = '';
            ESigningFormPersonalNumber.syncReceiverPersonalNumberInputState(form);
            return;
        }

        receiverPersonalNumberInput.dataset.fromDropdown = 'true';
        receiverPersonalNumberInput.dataset.rawValue = normalizedPersonalNumber;
        receiverPersonalNumberInput.value = ESigningFormPersonalNumber.maskPersonalNumberLastFour(form, normalizedPersonalNumber);
        ESigningFormPersonalNumber.syncReceiverPersonalNumberInputState(form);
    }

    /**
     * @description Clear dropdown personal number state when user edits manually
     * @param {*} form
     * @param {boolean} clearDisplayedValue
     * @returns void
     */
    static clearReceiverPersonalNumberDropdownState(form, clearDisplayedValue = false) {
        const receiverPersonalNumberInput = document.getElementById('ReceiverPersonalNumber');
        if (!receiverPersonalNumberInput || !ESigningFormPersonalNumber.isReceiverPersonalNumberFromDropdown()) {
            return;
        }

        receiverPersonalNumberInput.dataset.fromDropdown = 'false';
        receiverPersonalNumberInput.dataset.rawValue = '';

        if (clearDisplayedValue) {
            receiverPersonalNumberInput.value = '';
        }

        ESigningFormPersonalNumber.syncReceiverPersonalNumberInputState(form);
    }

    /**
     * @description Normalize and write back personal number input value
     * @param {*} form
     * @returns void
     */
    static formatReceiverPersonalNumber(form) {
        const receiverPersonalNumberInput = document.getElementById('ReceiverPersonalNumber');
        if (!receiverPersonalNumberInput) {
            return;
        }

        if (ESigningFormPersonalNumber.isReceiverPersonalNumberFromDropdown()) {
            const normalizedPersonalNumber = ESigningFormPersonalNumber.getReceiverPersonalNumberValue(form);
            receiverPersonalNumberInput.dataset.rawValue = normalizedPersonalNumber;
            receiverPersonalNumberInput.value = normalizedPersonalNumber
                ? ESigningFormPersonalNumber.maskPersonalNumberLastFour(form, normalizedPersonalNumber)
                : '';
            ESigningFormPersonalNumber.syncReceiverPersonalNumberInputState(form);
            return;
        }

        receiverPersonalNumberInput.value = ESigningFormPersonalNumber.normalizePersonalNumber(
            receiverPersonalNumberInput.value
        );
        ESigningFormPersonalNumber.syncReceiverPersonalNumberInputState(form);
    }
}